import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import BookingWizard from "./pages/BookingWizard";
import BookingSuccess from "./pages/BookingSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import StickyContact from "./components/StickyContact";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App" data-testid="app-root">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/book" element={<BookingWizard />} />
            <Route path="/booking-success/:id" element={<BookingSuccess />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <StickyContact />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
